module.exports = __webpack_public_path__ + "static/img/game_fk.f89e2a06.png";